import debounce from 'lodash.debounce';

class JobOfferList {
    constructor($list = null, $searchForm = null, $countryFilter = null) {
        this.$list = $list;
        this.$searchForm = $searchForm;
        this.$countryFilter = $countryFilter;

        this.options = {
            pageDots: true,
            wrapAround: false,
            prevNextButtons: true,
            cellSelector: '.bu-products__item'
        };

        if(this.$list.length && this.$searchForm.length && this.$countryFilter.length) {
            this._init();
        }
    }

    _init() {
        this.jobOffers = [];
        this.$jobOffers = [];
        this.$searchInput = null;

        this._findDOMElements();

        if(this.$jobOffers.length && typeof ver.jobOffers !== 'undefined') {
            this._createJobOffers();
            this._populateCountryFilter();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.$searchInput.on('keyup', debounce(this._refreshJobOffersList.bind(this), 150));
        this.$countryFilter.on('change', this._refreshJobOffersList.bind(this));
        this.$searchForm.on('submit', this._refreshJobOffersList.bind(this));
    }

    _findDOMElements() {
        this.$jobOffers = this.$list.find('.archive-offers_list-item');
        this.$searchInput = this.$searchForm.find('.archive-offers_terms-filter');
    }

    _createJobOffers() {
        this.$jobOffers.each((index, el) => {
            const $el = $(el);
            const jobOfferData = this._getJobOfferData(el.getAttribute('id'));

            if(jobOfferData && $el.length) {
                let terms = jobOfferData.search_terms.split(',');
                terms.push(jobOfferData.title);

                terms = terms.map(Function.prototype.call, String.prototype.trim);

                this.jobOffers.push({
                    $el: $el,
                    id: jobOfferData.id,
                    terms: terms,
                    country: jobOfferData.country,
                    state: 'visible'
                });
            }
        });
    }

    _populateCountryFilter() {
        let countries = [];
        let countryValuesTpl = '';

        this.jobOffers.forEach((jobOffer) => {
            if(!countries.includes(jobOffer.country)) {
                countries.push(jobOffer.country);
                countryValuesTpl += `<option value="${jobOffer.country}">${jobOffer.country}</option>`;
            }
        });

        if(countryValuesTpl.length) {
            this.$countryFilter.append(countryValuesTpl);
        }
    }

    _getJobOfferData(id) {
        var result = ver.jobOffers.find((jobOffer) => {
            return `job-offer-${jobOffer.id}` === id;
        });

        return result;
    }

    _refreshJobOffersList(e) {
        if(e.type = 'submit') {
            e.preventDefault();
        }

        const terms = this.$searchInput.val();
        const country = this.$countryFilter.val();
        let useCountryFilter = false;

        this.jobOffers.forEach((jobOffer) => {
            // Country filter
            if(country != -1) {
                useCountryFilter = true;

                if(country !== jobOffer.country) {
                    jobOffer.state = 'hidden';
                }
                else {
                    jobOffer.state = 'visible';
                }
            }

            // Terms filter
            if(terms.length >= 2) {
                const termsArray = terms.split(' ');

                const matchIndex = jobOffer.terms.findIndex((term) => {
                    return term.indexOf(terms) !== -1;
                });
                if(matchIndex === -1) {
                    jobOffer.state = 'hidden';
                }
                else {
                    if(!useCountryFilter) {
                        jobOffer.state = 'visible';
                    }
                }
            }
            else {
                if(!useCountryFilter) {
                    jobOffer.state = 'visible';
                }
            }
        });

        this.jobOffers.forEach((jobOffer) => {
            if(jobOffer.state === 'hidden') {
                jobOffer.$el.addClass('hidden');
            }
            else {
                jobOffer.$el.removeClass('hidden');
            }
        });
    }

    // _resetListVisibility() {
    //     this.$jobOffers.removeClass('hidden');
    // }
}

export default JobOfferList;
